import { render, staticRenderFns } from "./BackofficeRouteIndex.vue?vue&type=template&id=2800918b&scoped=true&"
import script from "./BackofficeRouteIndex.vue?vue&type=script&lang=js&"
export * from "./BackofficeRouteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800918b",
  null
  
)

export default component.exports